export const STORY_PLACEHOLDER =
  "Your story helps clients connect with you. Share your journey, what drives your art, and why you're the right choice—so they can see the person behind the profile. Add your story in Profile → Story to make this section shine.";
